
export const ENUM_TYPE = {
  VALIDATA: 'Validata',
  INSERITA: 'Inserita',
};
